import React from 'react';
import CssBaseline from '@mui/material/CssBaseline';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import {makeStyles} from 'tss-react/mui';
import Link from '@mui/material/Link';
import Container from '@mui/material/Container';
import Button from "@mui/material/Button";
import {connect} from "react-redux";
import {useLocation, useNavigate} from "react-router-dom";
import { getActiveItinerary  } from '../../@opentripplanner/core-utils/src/state'
import RenderPriceTable from './render-price-table.js'
import { createAction } from 'redux-actions'
import {setPriceScreen} from "../../actions/ui";
import { useFont } from '../../contexts/FontContext';
import { useQueryParams } from '../../hooks/useQueryParams';

export const clearActiveSearch = createAction('CLEAR_ACTIVE_SEARCH')

function renderElectionRoutes(prices){
    if(!prices)
        return null;
   let result = prices.legs.map((leg,index) => {

        return (<div key={'leg' + index} style={{fontSize:13}}><b>{leg.route}</b>{" " + 
        leg.price.agency_name + " - "} {(leg.isFreeOnElections ? "בחינם" : "בתשלום")}
        
        
        </div>)
       


   })
   return result;
}

/*    <div className={classes.footer}>
  <p style={{fontSize:15}}><b>הבחירות לכנסת ה-24 - נסיעות בתחבורה הציבורית</b></p>
  <p style={{fontSize:13}}>
  החל מיום שני, 22.3.3031 בשעה 20:00 ועד לתום השירות ביום הבחירות, שלישי, 23.3.2021, תתאפשר נסיעה ללא תשלום ברכבת ישראל ובקווי האוטובוסים הבין עירוניים.
לנסיעה ברכבת ישראל יש להזמין מקום מראש באתר הרכבת ולהוציא כרטיס נסיעה ייעודי בחינם בקופות או במכונת הכרטיסים שבתחנה. באוטובוסים הבין עירוניים לא נדרש לתקף את הנסיעה באמצעות כרטיס הרב-קו/סריקת ברקוד, פשוט עולים ונוסעים!    
  </p>
  מידע על נסיעות במסלול הנבחר ביום הבחירות:
  {renderElectionRoutes(props.prices)}
</div>*/

function PricesResult(props) {
    const { currentFont } = useFont();
    const { navigateWithParams } = useQueryParams();
    
    const useStyles = makeStyles()((theme) => ({
        paper: {
            marginTop: theme.spacing(8),
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            overflowY:'scroll'
        },
        defaultSearchResult:{
            marginTop: theme.spacing(4),
        },
        text:
            {
                marginTop: theme.spacing(2),
            },
        submit: {
                margin: theme.spacing(4, 2, 4,2),
                backgroundColor: '#22a7f0',
                fontFamily: currentFont,
                color:'black',
                maxWidth:320
            },
        fontText:
            {
                fontFamily: currentFont
            },
        footer:{
            
            left: 0,
            bottom: 0,
            width:'100%',
            color: 'black',
            textAlign:'center',
            fontFamily: currentFont,
            fontWeight:300,
            paddingLeft:16,
            paddingRight:16,
            fontSize:12,
            marginBottom:60,
            backgroundColor:'#fafafa'
        },
        container:{
            overflowY:'scroll'
        }
    }));

    const {classes} = useStyles();
    const history = useNavigate();
    const location = useLocation();

   
    const {
        textEndBtn
    } = props
    //const search = props.activeSearch;
   // const response = search && (search.response || search.nonRealtimeResponse )
    //const itineraries =  response && response.plan && response.plan.itineraries;
  
    const onClick = () => {
        props.clearSearch();
        navigateWithParams("/transit_prices/select-trip");
    }

    const closeScreen = () => {
        props.setPriceScreen(false);
    }

    return (
        <div className={classes.container}>
        <Container dir={'rtl'} component="main" maxWidth="sm">
            <CssBaseline/>
            <div className={classes.paper}>
                <Box className={classes.box}>
                    <Typography component="h6" variant="h5" align="center" className={classes.fontText}>
                       השוואת מחירי נסיעה למסלול
                    </Typography>
                </Box>
            
                <div className={'otp'} style={{alignItems:'right',marginTop: "40px"}}>
                    
                    {<RenderPriceTable 
                    tripPrices={props.prices}
                    location={location} />}
                </div>
                {textEndBtn && <Button
                    type="button"
                    fullWidth
                    variant="contained"
                    color="primary"
                    className={classes.submit}
                    onClick={closeScreen}
                    disableElevation>
                    {textEndBtn}
                </Button>
                }

                {!textEndBtn && <Button
                    type="button"
                    fullWidth
                    variant="contained"
                    color="primary"
                    className={classes.submit}
                    onClick={onClick}
                    disableElevation>
                    חיפוש נוסף
                </Button>
                }

{(!location || !location.search.includes("embed=ravpass")) &&
                (<Link
    className={classes.download}
    target="_blank"
    href='https://ravkav.ravpass.com/get'
    underline="hover">להורדת האפליקציה</Link>)
            }

<div className={classes.footer}>
  <p>התעריפים המוצגים וההמלצות מיועדים להמחשה בלבד ועבור נסיעות של נוסע בעל פרופיל רגיל, ועשויים להיות לא מדוייקים ואף שונים בהתאם לנסיעות שיובצעו בפועל ולפרופיל הנוסע. השימוש במידע באחריותך בלבד. בכפוף ל<a style={{color:'grey'}} target='_blank' rel="noreferrer" href='https://s3-eu-west-1.amazonaws.com/static.hopon.co.il/app_terms/isra-pass/terms.html'>תנאי השימוש</a></p>
</div>
            </div>

        </Container>
        </div>
    );
}

const mapStateToProps = (state, ownProps) => {
    return {
        itinerary: getActiveItinerary(state.otp),
        prices:state.otp.activeItineraryPrices

    }
}

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        clearSearch: () => { dispatch(clearActiveSearch()) },
        setPriceScreen: (x) => { dispatch(setPriceScreen(x)) }

    }
}
export default connect(mapStateToProps, mapDispatchToProps)(PricesResult)